// Globals
import { useTranslation } from 'react-i18next';

// Models
import { IRobotsData } from '@/models/seo.model';

// Components
import { StyledItem, StyledLabel, StyledValue, StyledWrapper } from './RobotsInfoStyles';

interface IRobotsInfoProps {
  robotsData: IRobotsData | null;
}

const RobotsInfo = ({ robotsData }: IRobotsInfoProps) => {
  const { t } = useTranslation(['seo']);

  return (
    <StyledWrapper>
      <StyledItem>
        <StyledLabel>{t('seo_robots_tab_title')}</StyledLabel>
        <StyledValue>{robotsData?.content}</StyledValue>
      </StyledItem>
    </StyledWrapper>
  );
};

export default RobotsInfo;
